import React from "react";

/**
 * Live-platform-style verified badge — a blue 10-point scalloped circle with a
 * crisp white checkmark in the center. Used inline next to verified
 * seller/collector names across the site.
 *
 * Props:
 *   visible: if false (or falsy), renders nothing. Lets callers pass
 *            the raw user flag: `<VerifiedBadge visible={user?.verified_badge} />`.
 *   size: pixel width/height (default 14)
 *   className: extra classes for positioning
 */
export default function VerifiedBadge({ visible = true, size = 14, className = "" }) {
  if (!visible) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={`inline-block flex-shrink-0 ${className}`}
      aria-label="Verified"
      data-testid="verified-badge"
    >
      {/* Scalloped blue badge — 10 rounded petals forming a flower silhouette */}
      <path
        d="M12 1.5 L14.2 3.35 L16.95 2.6 L18.15 5.2 L20.9 5.95 L20.65 8.75 L22.5 10.9 L20.65 13.05 L20.9 15.85 L18.15 16.6 L16.95 19.2 L14.2 18.45 L12 20.3 L9.8 18.45 L7.05 19.2 L5.85 16.6 L3.1 15.85 L3.35 13.05 L1.5 10.9 L3.35 8.75 L3.1 5.95 L5.85 5.2 L7.05 2.6 L9.8 3.35 Z"
        fill="#20D5EC"
      />
      {/* White checkmark */}
      <path
        d="M8.2 11.4 L10.8 14 L15.9 8.9"
        stroke="#FFFFFF"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
